module.exports = __webpack_public_path__ + "static/media/no-icon.36ab181d.svg";